import { graphql } from 'react-relay';
import { useRelayFetchQuery } from '../relay.utils';
import type { Tag_Search_Query } from './Tag.query';
import type { Tags_Pagination_Query$variables } from './__generated__/Tags_Pagination_Query.graphql';

const TagsFragment = graphql`
  fragment Tags_Fragment on Tag {
    id
    name
    count
    description
  }
`;

export type Tag_Pagination_Fragment$args = Tags_Pagination_Query$variables;
export type {
  Tags_Pagination_Query,
  Tags_Pagination_Query$variables,
} from './__generated__/Tags_Pagination_Query.graphql';
export type {
  Tag_Pagination_Fragment$key,
  Tag_Pagination_Fragment$data,
} from './__generated__/Tag_Pagination_Fragment.graphql';
export const TagsPaginationFragment = graphql`
  fragment Tag_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToTagConnectionWhereArgs" }
  )
  @refetchable(queryName: "Tags_Pagination_Query") {
    tags(first: $first, after: $after, where: $where) @connection(key: "Tags_Pagination_Fragment_Connection_tags") {
      __id
      edges {
        node {
          ...Tags_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export * from './__generated__/Tags_Query.graphql';
export const TagsQuery = graphql`
  query Tags_Query($first: Int = 12, $after: String = null, $where: RootQueryToTagConnectionWhereArgs = null) {
    ...Tag_Pagination_Fragment
      @arguments(
        first: $first
        after: $after
        where: $where
      )
  }
`;

export type {
  Tag_Search_Query,
  Tag_Search_Query$variables,
  Tag_Search_Query$data,
} from './__generated__/Tag_Search_Query.graphql';
export const TagSearchQuery = graphql`
  query Tag_Search_Query($first: Int = 12, $after: String, $where: RootQueryToTagConnectionWhereArgs) {
    tags(first: $first, after: $after, where: $where) {
      edges {
        node {
          name
          id
        }
      }
    }
  }
`;

export const useTagSearchQuery = () => {
  return useRelayFetchQuery<Tag_Search_Query>(TagSearchQuery);
};
